
@if (downloadProgress !== 100 && !displayLoadingErrorMessage) {
  <div class="loadingProgress">
    <div>Loading...@if (downloadProgress !== 0) {
      <span>({{downloadProgressDisplay}}%)</span>
    }</div>
    <mat-progress-bar [mode]="progressBarMode" [value]="downloadProgress" ></mat-progress-bar>
  </div>
}

@if (displayLoadingErrorMessage) {
  <div class="loadingError">
    Error: The file could not be loaded.
  </div>
}

<div class="pdfViewerContainer" #pdfViewerContainer>
  <ngx-extended-pdf-viewer #pdfView class="pdfViewer" [src]="srcURL" delayFirstView="250"  [zoom]="zoom" [httpHeaders]="headers" [enablePrint]="false"
    [showOpenFileButton]="false" [showSecondaryToolbarButton]="false" [height]="height" [textLayer]="false"
    (progress)="onDownloadProgress($event)" (pdfLoadingFailed)="onLoadingError($event)" >
  </ngx-extended-pdf-viewer>
  <div class="resize-handle" (mousedown)="startResize($event)" title="drag right or left to resize"></div>
</div>
